import React, { useState, useEffect, useContext, useRef } from "react";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment/moment";
import { formatNumber, isNumeric } from "../../helpers/formater";
import NewClient from "../Items/NewClient";
import useAuthHelper from "../../helpers/AuthHelper";

/**
 * create new Incoice
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const NewDevis = (props) => {
  const { onlyCommercial, hadAddAccess } = useAuthHelper();

  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [clients, setClients] = useState([]);
  const [products, setProducts] = useState([]);

  //new product to invoice state
  const [productId, setProductId] = useState();
  const [qty, setQty] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [tva, setTva] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [totalTtc, setTotalTtc] = useState(0);

  const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  let invoiceProducts = [];
  const [totalTTc, setTotalTTC] = useState();
  const [isService, setIsService] = useState(false);

  //useRef
  const leTotalHt = useRef(0);
  const leTotalTTc = useRef(0);

  //summary
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);

  //edit product
  const [productIdToEdit, setProductIdToEdit] = useState(0);
  const [prdctData, setPrdctData] = useState();

  //form state
  /**
   * {
   *     "value": 92,
   *     "label": "test testchoulla"
   * }
   */
  const currentYear = new Date().getFullYear();
  const firstDayOfYear = `${currentYear}-01-01`;
  const lastDayOfYear = `${currentYear}-12-31`;
  const date_now = new Date();
  const [client, setClient] = useState([]);
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState(
    date_now ? moment(date_now).format("yyyy-MM-DD") : "",
  );
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const [objet, setObjet] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const [payedAmount, setPayedAmount] = useState(0);
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [lastInvoiceNumber, setLastInvoiceNumber] = useState(0);
  const [numeroDeLaFacture, setNumeroDeLaFacture] = useState(0);
  const [selectedProductQty, setSelectedProductQty] = useState(0);
  const [isSubmit, setIsSubmit] = useState(false);
  const [nbInvoices, setNbInvoices] = useState(0);
  const [invoicesNums, setInvoicesNums] = useState([]);
  const [numExist, setExitNum] = useState(false);

  const [selectedDepotId, setSelectedDepotId] = useState(0);

  const MAX_TITLE_LENGTH = 255;

  useEffect(() => {
    onlyCommercial();
    hadAddAccess();
    console.log("tchanga", invoiceProductsState);
    calcInvoiceSummary(invoiceProductsState);
  }, [invoiceProductsState]);

  const handleAutoIncrementInvoiceNumber = () => {
    if (autoIncrementInvoiceNumber === false) {
      $("#invoiceNumberInput").css("display", "none");
    } else {
      $("#invoiceNumberInput").css("display", "block");
    }
  };
  /**
   * get all associated clients
   *
   * @returns {Promise<void>}
   */
  const getAllAssociatedClients = async () => {
    const response = await axios
      .get(baseURL + `/client/getbyuser/${user.id}/client/${organisation.id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
          $("#warning-create-client-first").css("display", "block");
        } else {
          $("#warning-create-client-first").css("display", "none");
          setClients(transformClientsArray(response.data.data));
          console.log("lcintes : ", clients);
          /**
           * {
           *     "value": 56,
           *     "label": "Commodi minus omnis Ipsum ullam architec"
           * }
           */
        }
      })
      .catch((error) => console.log("error " + error));
  };

  const getAllAssociatedProducts = async () => {
    const response = await axios
      .get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
      .then((response) => {
        setProducts(transformProductsArray(response.data.data));
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error),
      );
  };

  const transformClientsArray = (clients) => {
    let array = [];
    for (let i = 0; i < clients.length; i++) {
      let obj = {
        value: clients[i].id,
        label: clients[i].companyName + " - " + clients[i].account.code,
      };
      array.push(obj);
    }
    return array;
  };

  const calcInvoiceSummary = (invoiceProducts) => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;
    // {
    //     "name": "Funny Morning Sarcastic SVG, Sarcastic Morning SVG, Sarcastic SVG, Sarcasm svg, Funny Mug svg,Cut File for Cricut,Silhouette",
    //     "qty": "1",
    //     "unitPrice": 100,
    //     "tva": 20,
    //     "totalHt": "100",
    //     "totalTtc": "120"
    // },
    for (let i = 0; i < invoiceProductsState.length; i++) {
      totalHt += parseFloat(invoiceProductsState[i].totalHt);
      totalTtc += parseFloat(invoiceProductsState[i].totalTtc);
      totalTva +=
        parseFloat(invoiceProductsState[i].totalTtc) -
        parseFloat(invoiceProductsState[i].totalHt);
    }
    setSummaryTotatlHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotatlTtc(totalTtc);
  };
  const hideOffcanvas = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");

    const offcanvas =
      window.bootstrap?.Offcanvas.getInstance(offcanvasElement) ||
      new window.bootstrap.Offcanvas(offcanvasElement);

    offcanvas.hide();
  };
  const addNewProductToInvoice = async () => {
    /**
     * singleSelectedProduct ok
     * qty,unitPrice ok
     * leTotalHt.current.value : ok
     * leTotalTTc.current.value : OK
     *
     */
    if (selectedProduct.value === null || qty === 0) {
      $("#all-fields-are-required").css("display", "block");
    } else {
      hideOffcanvas();
      $("#all-fields-are-required").css("display", "none");
      if (checkIfProductAlreadyExist(singleSelectedProduct.value)) {
        $("#warning-product-already-exists").css("display", "block");
      } else {
        $("#warning-product-already-exists").css("display", "none");
        /**
         * prepare product
         * @type {{unitPrice: number, qty: number, name, totalTtc, totalHt, tva: number}}
         */
        let product = {
          product_id: singleSelectedProduct.value,
          name: singleSelectedProduct.label,
          qty: qty,
          unitPrice: unitPrice,
          tva: tva,
          totalHt: leTotalHt.current.value,
          totalTtc: leTotalTTc.current.value,
          depot_id: selectedDepotId,
        };
        invoiceProducts.push(product);
        setInvoiceProductsState([...invoiceProductsState, product]);
      }
    }
  };

  const checkIfProductAlreadyExist = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        console.log("exist");
        return true;
      }
    }
    console.log("! exist");
    return false;
  };
  const [depotsProduct, setDepotsProduct] = useState([]);

  const getProductData = async (selectedProduct) => {
    // Met à jour la quantité du produit sélectionné
    // setSelectedProductQty(selectedProduct.qty);

    try {
      const response = await axios.get(
        `${baseURL}/product/get/${selectedProduct.value}`,
      );

      // Vérifie si la réponse est valide et contient des données
      if (response.data.data && response.data.data.length > 0) {
        const productData = response.data.data[0]; // Premier élément du tableau
        setUnitPrice(productData.sellingPrice); // Définit le prix unitaire
        console.log("Données du produit :", productData);

        // Vérifie si le type du produit est un service
        if (productData.type === "Services") {
          setIsService(true);
          setQty(1); // Quantité pour les services
        } else {
          setIsService(false);
          setQty(0); // Quantité pour les autres produits
        }
        setDepotsProduct(productData.depot);
        // Met à jour la TVA selon les informations du produit
        setTva(productData.taxe_vente?.rate || 0);
      }
    } catch (error) {
      console.log(
        "Erreur lors de la récupération des données du produit :",
        error,
      );
    }
  };

  const transformProductsArray = (products) => {
    let array = [];
    for (let i = 0; i < products.length; i++) {
      let obj = {
        value: products[i].id,
        label: products[i].name,
        unit_price: products[i].sellingPrice,
        depots: products[i].depot,
      };
      array.push(obj);
    }
    return array;
  };

  const getNbsInvoices = async () => {
    let resp = await jwtInterceoptor.get(
      `/data/nb-factures/devis/${organisation?.id}`,
    );
    if (resp.status == 200) {
      let data = resp.data;
      if (data?.status) {
        setNbInvoices(data?.nb_factures);
        setInvoicesNums(data.data);
      }
    }
  };

  useEffect(() => {
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");
    getAllAssociatedClients();
    getAllAssociatedProducts();
    getInvoiceStatus();
    getIncrementedInvoiceNumber();
    getNbsInvoices();
  }, []);
  const getInvoiceStatus = async () => {
    const response = await jwtInterceoptor
      .get("data/user/status/devis")
      .then((res) => {
        setInvoiceStatus(res.data.data);
      })
      .catch((error) => console.log(error));
  };
  const deleteSingleProduct = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        invoiceProductsState.splice(i, 1);
        console.log("spliced");
      }
    }
    setInvoiceProductsState([...invoiceProductsState]);
  };

  const editSingleProduct = (productId) => {
    $(".select-article").css("display", "none");
    $(".add-new-product-to-invoice-btn").css("display", "none");
    $(".edit-single-product").css("display", "revert");
    setProductIdToEdit(productId);

    let product = invoiceProductsState.filter(
      (p) => p.product_id === productId,
    );
    // getProductData(productId)
    setQty(product[0]["qty"]);
    setUnitPrice(product[0]["unitPrice"]);
    setTva(product[0]["tva"]);
    setSelectedDepotId(product[0]["depot_id"]);
  };

  const editSingleInvoiceProduct = () => {
    if (
      selectedProduct.value === null ||
      qty === 0 ||
      unitPrice === 0 ||
      leTotalHt.current.value === 0 ||
      leTotalTTc.current.value === 0
    ) {
      toast.warning(t("Tous les champs sont obligatoire !"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      $("#all-fields-are-required").css("display", "none");
      hideOffcanvas();
      for (let i = 0; i < invoiceProductsState.length; i++) {
        if (invoiceProductsState[i].product_id === productIdToEdit) {
          invoiceProductsState[i].qty = qty;
          invoiceProductsState[i].unitPrice = unitPrice;
          invoiceProductsState[i].totalHt = leTotalHt.current.value;
          invoiceProductsState[i].totalTtc = leTotalTTc.current.value;
          invoiceProductsState[i].depot_id = selectedDepotId;
        }
        setInvoiceProductsState([...invoiceProductsState]);
      }
    }
  };

  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    emptyInputs();
  };
  const emptyInputs = () => {
    setSingleSelectedProduct([]);
    setSelectedProduct([]);
    setQty(0);
    setUnitPrice("");
    setTva(0);
    setTotalHt("");
    setTotalTTC("");
    setIsService(false);
  };
  const getIncrementedInvoiceNumber = async () => {
    let value = 0;
    const response = await jwtInterceoptor
      .get("/data/user/devis/last/" + organisation.id)
      .then((res) => {
        if (res.data.data !== null) {
          setNumeroDeLaFacture(res.data.data.id + 1);
        } else {
          setNumeroDeLaFacture(1);
        }
      })
      .catch((error) => console.log("error while save", error));
  };

  const save = () => {
    if (objet.trim().length > MAX_TITLE_LENGTH) {
      toast.error(
        t(`Le titre ne doit pas dépasser ${MAX_TITLE_LENGTH} caractères.`),
        {
          position: "top-right",
          autoClose: 5000,
          theme: "colored",
        },
      );
      return;
    }
    if (
      numExist ||
      client.value === undefined ||
      invoiceDueDate.length === 0 ||
      invoiceCreatedAt.length === 0 ||
      invoiceProductsState.length === 0 ||
      objet.length === 0 ||
      selectedStatus === 0 ||
      selectedStatus === "" ||
      (autoIncrementInvoiceNumber === false && invoiceNumber === "")
    ) {
      toast.error("Tous les champs sont obligatoire !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      let numeroDeFacture = "";

      let preparedProducts = [];
      /**
       *
       * @type {number}
       */
      let is_custom_invoice_number = 0;
      /**
       *
       * @type {number}
       */
      let incrementedValue = 0;
      if (autoIncrementInvoiceNumber === false) {
        is_custom_invoice_number = 1;
        numeroDeFacture = isNumeric(invoiceNumber)
          ? `DEVIS-${formatNumber(invoiceNumber)}`
          : `DEVIS-${invoiceNumber}`;
      } else {
        numeroDeFacture = nbInvoices + 1;
      }

      for (let i = 0; i < invoiceProductsState.length; i++) {
        const ref = Math.random().toString(36).substring(2, 7);
        let obj = {
          product_id: invoiceProductsState[i].product_id,
          price_unit_ht: invoiceProductsState[i].unitPrice,
          qty: invoiceProductsState[i].qty,
          total_ht: invoiceProductsState[i].totalHt,
          total_ttc: invoiceProductsState[i].totalTtc,
          tva: invoiceProductsState[i].tva,
          reference: ref,
          depot_id: invoiceProductsState[i].depot_id,
        };
        preparedProducts.push(obj);
      }

      const prepareObject = {
        user_id: user.id,
        organisation_id: organisation.id,
        client_id: client.value,
        total_ht: summaryTotatlHt,
        total_ttc: summaryTotatlTtc,
        total_tva: summaryTotalTva,
        title: objet,
        due_date: invoiceDueDate,
        created_at_date: invoiceCreatedAt,
        status: selectedStatus,
        payed_amount: payedAmount,
        products: preparedProducts,
        invoice_number: numeroDeFacture,
        is_custom_invoice_number: is_custom_invoice_number,
      };
      saveInvoice(prepareObject);
    }
  };

  const saveInvoice = async (invoice) => {
    setIsSubmit(true);
    const response = await jwtInterceoptor
      .post("/data/user/devis/add", invoice)
      .then((res) => {
        if (!res?.data || res.data.status === false || res.data.error) {
          Swal.fire(
            t("Erreur"),
            t(res?.data?.message || "La facture n'a pas pu être créée"),
            "error",
          );
          return;
        }
        setIsSubmit(false);
        Swal.fire(t("Le devis est créer avec succès"), t(""), "success");
        navigate("/sales/devis/list");
      })
      .catch((error) => {
        setIsSubmit(false);
        console.log("error while save", error);
      });
  };

  const onSaveClient = () => {
    getAllAssociatedClients();
    window.$("#newClientModal").modal("hide");
    console.log("has been saved");
    Swal.fire(t("Le client a été ajouter avec succès"), t(""), "success");
  };

  return (
    <>
      <ToastContainer />

      <div className="main-container container-fluid">
        <GoBack route="/sales/devis/list" />

        <div className="page-header">
          <h1 className="page-title breadcumpsHeader">{t("Devis")}</h1>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="javascript:void(0)"
                  onClick={() => navigate("/sales/devis/list")}
                >
                  {t("Liste des devis")}
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {t("Ajouter un devis")}
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0 all-fields-are-required-to-save"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong></strong> {t("Tous les champs sont obligatoire !")}
                </span>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <br />
              <div
                class="modal fade"
                id="newClientModal"
                tabIndex="-1"
                aria-labelledby="newClientModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="newClientModal">
                        {t("Ajouter un nouveaux client")}
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <NewClient
                        clientType={"client"}
                        from={"new_fv"}
                        handleSave={onSaveClient}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <h4>{t("Espace client")}</h4>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("Nom du client")}*
                    </label>
                    <Select
                      options={clients}
                      onChange={(choice) => setClient(choice)}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("Nouveau Client")}
                    </label>
                    <a
                      className="btn btn-primary form-control"
                      data-bs-toggle="modal"
                      data-bs-target="#newClientModal"
                    >
                      <i className="fe fe-user"></i> {t("ajouter un client")}
                    </a>
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h4>{t("Informations sur la facture")}</h4>
              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("N° du devis")} * (
                      {t(
                        "ce numéro servira de référence pour votre devis originale",
                      )}
                      )
                    </label>
                    <input
                      type="text"
                      placeholder="Devis-0001"
                      className={`form-control `}
                      onChange={(e) => {
                        setInvoiceNumber(e.target.value);
                        let numExist = invoicesNums.findIndex(
                          (c) =>
                            e.target.value == c?.invoice_number ||
                            e.target.value ==
                              (c.is_custom_invoice_number == 1
                                ? c.invoice_number
                                : `Devis-${formatNumber(c?.invoice_number)}`),
                        );
                        if (numExist != -1) {
                          setExitNum(true);
                        } else {
                          setExitNum(false);
                        }
                      }}
                      value={invoiceNumber}
                      id={"invoiceNumberInput"}
                    />
                    {!autoIncrementInvoiceNumber && numExist ? (
                      <span className={"text-danger"}>
                        {t("Ce numéro de devis existe déjà")}
                      </span>
                    ) : null}
                    <label className="custom-control custom-checkbox-md">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        name="example-checkbox5"
                        value="option5"
                        checked={autoIncrementInvoiceNumber}
                        onClick={() =>
                          setAutoIncrementInvoiceNumber(
                            !autoIncrementInvoiceNumber,
                          )
                        }
                        onChange={(e) => {
                          handleAutoIncrementInvoiceNumber();
                        }}
                      />
                      <span class="custom-control-label">
                        {t("Utiliser le numéro du devis auto-incrementer")}
                      </span>
                    </label>
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {"Objet"}*
                    </label>
                    <input
                      id="invoiceTitle"
                      type="text"
                      placeholder="objet"
                      className="form-control"
                      value={objet}
                      // maxLength={MAX_TITLE_LENGTH}
                      onChange={(e) => setObjet(e.target.value)}
                      // aria-invalid={objet.length > MAX_TITLE_LENGTH}
                      aria-describedby="invoice-title-help"
                    />
                    <small
                      id="invoice-title-help"
                      className={
                        objet.length > MAX_TITLE_LENGTH
                          ? "text-danger"
                          : "text-muted"
                      }
                    >
                      {objet.length}/{MAX_TITLE_LENGTH} caractères maximum
                    </small>
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h5>{t("Les dates")}</h5>
              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("date de devis")}*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceCreatedAt(e.target.value)}
                      value={invoiceCreatedAt}
                      min={firstDayOfYear}
                      max={lastDayOfYear}
                    />
                  </div>
                </div>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("date d'échéance")}*
                    </label>
                    <input
                      type="date"
                      placeholder="nom"
                      className={`form-control `}
                      onChange={(e) => setInvoiceDueDate(e.target.value)}
                      value={invoiceDueDate}
                      min={firstDayOfYear}
                    />
                  </div>
                </div>
              </div>
              <hr className={"custom-hr"} />
              <h5>{t("Produits/Services")}</h5>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">{t("DÉTAILS DE L’ARTICLE")}</th>
                    <th scope="col">{t("QUANTITÉ")}</th>
                    <th scope="col">{t("PU HT")}</th>
                    <th scope="col">{t("TVA")} %</th>
                    <th scope="col">{t("Total HT")}</th>
                    <th scope="col">{t("Total TTC")}</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                {invoiceProductsState.map((product) => {
                  return (
                    <tr key={product.product_id}>
                      <td>{product.name}</td>
                      <td>{product.qty}</td>
                      <td>{product.unitPrice}</td>
                      <td>{product.tva + "%"}</td>
                      <td>{product.totalHt}</td>
                      <td>{product.totalTtc}</td>
                      <td>
                        <i
                          onClick={() =>
                            deleteSingleProduct(product.product_id)
                          }
                          class="fe fe-trash"
                        ></i>
                      </td>
                      <td>
                        <i
                          data-bs-toggle="offcanvas"
                          aria-controls="offcanvasBottom"
                          data-bs-target="#offcanvasBottom"
                          onClick={() => editSingleProduct(product.product_id)}
                          class="fe fe-edit"
                        ></i>
                      </td>
                    </tr>
                  );
                })}
              </table>
              <center>
                <button
                  onClick={changeOfCanvasLayouts}
                  className="btn btn-primary off-canvas btn-sm mb-1"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasBottom"
                  aria-controls="offcanvasBottom"
                >
                  <i className="fe fe-plus"></i>
                  {t("ajouter un article")}
                </button>
              </center>

              <hr className={"custom-hr"} />
              <div className={"row"}>
                <div className={"col-md-6"}></div>
                <div className={"col-md-6 d-flex flex-row-reverse"}>
                  <div className="row">
                    <div className="invoiceSummary">
                      <table>
                        <tr>
                          <td className={"invoiceSummary-base"}>
                            {"Total HT"} :
                          </td>
                          <td>
                            {Number(summaryTotatlHt).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>
                            {t("Total TVA")} :
                          </td>
                          <td>
                            {Number(summaryTotalTva).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                        <tr>
                          <td className={"invoiceSummary-base"}>
                            {t("Total TTC")} :
                          </td>
                          <td>
                            {Number(summaryTotatlTtc).toFixed(2)}{" "}
                            {organisation?.currency?.code}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className={"row"}>
                <div className={"col-md-6"}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("Etat")}*
                    </label>
                    <select
                      className="form-select"
                      id="buyPriceAccountInput"
                      onChange={(e) => setSelectedStatus(e.target.value)}
                      value={selectedStatus}
                    >
                      <option value="0">
                        {t("selectionner L'état du devis")}
                      </option>
                      {invoiceStatus.map((status) => {
                        return <option value={status.id}>{status.name}</option>;
                      })}
                    </select>
                  </div>
                </div>
              </div>

              <br />
              <div class="card-footer">
                <div className="d-flex flex-row-reverse">
                  <button
                    disabled={isSubmit}
                    type="button"
                    className="btn btn-primary"
                    onClick={save}
                  >
                    {isSubmit ? t("Loading ...") : t("Enregistrer")}
                  </button>
                  <a
                    onClick={() => {
                      navigate(-1);
                    }}
                    className="btn btn-default "
                    style={{ marginRight: 10 }}
                  >
                    {t("Annuler")}
                  </a>
                </div>
              </div>

              <div
                className="offcanvas offcanvas-bottom addProductCanvas"
                tabIndex="-1"
                id="offcanvasBottom"
                aria-labelledby="offcanvasBottomLabel"
              >
                <div className="offcanvas-header">
                  <h5 className="offcanvas-title" id="offcanvasBottomLabel">
                    {t("Renseigner le produit à ajouter.")}
                  </h5>
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  >
                    <i className="fe fe-x fs-18"></i>
                  </button>
                </div>
                <div className="offcanvas-body">
                  <div id="all-fields-are-required">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        <strong>Attention!</strong>{" "}
                        {t("Tous les champs sont obligatoire")} !
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="warning-product-already-exists">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        <strong>Attention!</strong> Le produit déja exist !
                      </span>
                    </div>
                    <br />
                  </div>

                  <div id="qty-is-higher">
                    <div
                      className="alert alert-danger alert-dismissible fade show mb-0"
                      role="alert"
                    >
                      <span className="alert-inner--icon">
                        <i className="fe fe-slash"></i>
                      </span>
                      <span className="alert-inner--text">
                        {/* <strong>Attention!</strong>Il ne reste plus que {selectedProductQty}{" "}
                        articles en stock{" "} */}
                        {selectedProductQty === 0 ? (
                          <strong>Rupture de stock</strong>
                        ) : (
                          <>
                            <strong>Attention!</strong> Il ne reste plus que{" "}
                            {selectedProductQty} articles en stock
                          </>
                        )}
                      </span>
                    </div>
                    <br />
                  </div>

                  <form className="needs-validation" noValidate="">
                    <div className="form-row">
                      <div className="col-xl-12 mb-3">
                        <label
                          className={"select-article"}
                          htmlFor="validationTooltip01"
                        >
                          {t(" DÉTAILS DE L’ARTICLE*")}
                        </label>
                        <Select
                          className={"select-article"}
                          value={singleSelectedProduct}
                          options={products}
                          onChange={(choice) => {
                            setQty(0); // Réinitialise la quantité
                            console.log("Produits disponibles :", products);

                            setSingleSelectedProduct(choice); // Définit le produit sélectionné
                            getProductData(choice); // Récupère les données du produit
                            setIsService(choice?.type === "Services"); // Met à jour l'état selon le type
                            console.log("Produit sélectionné :", choice);
                          }}
                        />
                      </div>
                      <div className="col-xl-12 mb-3">
                        {depotsProduct?.length > 0 && (
                          <>
                            <label htmlFor="productDepots">
                              {t("Dépôts disponibles")}
                            </label>
                            {depotsProduct.map((depot, index) => (
                              <div key={index} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  id={`depot-${index}`}
                                  value={depot.depot_id}
                                  name="productDepot"
                                  onChange={(e) => {
                                    setSelectedDepotId(e.target.value);
                                    setSelectedProductQty(depot.quantity);
                                    console.log("productDepot", e.target.value);
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`depot-${index}`}
                                >
                                  {depot.depot.name}
                                </label>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                      <div className="col-xl-3 mb-3" hidden={isService}>
                        <label htmlFor="validationTooltip02">
                          {t("QUANTITÉ")}*
                        </label>
                        <input
                          className="form-control"
                          id="validationTooltip02"
                          type="number"
                          required
                          value={qty}
                          onChange={(e) => {
                            if (e.target.value > selectedProductQty) {
                              $("#qty-is-higher").css("display", "block");
                            } else {
                              $("#qty-is-higher").css("display", "none");

                              // Parse the quantity to a float and handle negative values
                              const inputValue = parseFloat(
                                parseFloat(e.target.value).toFixed(2),
                              );

                              // Vérifie si la valeur saisie est un nombre valide
                              if (isNaN(inputValue) || inputValue < 0) {
                                setQty(0); // Réinitialise la quantité en cas de saisie invalide
                                setTotalHt("0.00");
                                setTotalTTC("0.00");
                                return;
                              }

                              // Vérifie si la quantité dépasse le stock disponible
                              if (inputValue > selectedProductQty) {
                                setQty(inputValue);
                                setTotalHt("0.00");
                                setTotalTTC("0.00");
                                return;
                              }

                              // Calcule les valeurs
                              const totalHtl = (inputValue * unitPrice).toFixed(
                                2,
                              );
                              const totalTTC = (
                                parseFloat(totalHtl) +
                                (parseFloat(totalHtl) * tva) / 100
                              ).toFixed(2);

                              // Met à jour l'état
                              setQty(inputValue);
                              setTotalHt(totalHtl);
                              setTotalTTC(totalTTC);
                            }
                          }}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">
                          {t("PU HT")}*
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          // required=""
                          value={unitPrice}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            if (!isNaN(value)) {
                              let total_ht = qty * value;
                              let total_ttc = (
                                parseFloat(total_ht) +
                                (parseFloat(total_ht) * tva) / 100
                              ).toFixed(2);
                              setUnitPrice(parseFloat(value.toFixed(2)));
                              setTotalHt(parseFloat(total_ht.toFixed(2)));
                              setTotalTTC(total_ttc);
                            }
                          }}
                          // disabled={!isService}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">
                          {t("Total HT")}*
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={isService ? unitPrice.toFixed(2) : totalHt}
                          ref={leTotalHt}
                        />
                      </div>
                      <div className="col-xl-3 mb-3">
                        <label htmlFor="validationTooltip02">
                          {t("Total TTC")}*
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="validationTooltip02"
                          required=""
                          value={
                            isService
                              ? (
                                  parseFloat(unitPrice.toFixed(2)) +
                                  (parseFloat(unitPrice.toFixed(2)) * tva) / 100
                                ).toFixed(2)
                              : totalTTc
                          }
                          ref={leTotalTTc}
                        />
                      </div>
                    </div>
                    <i
                      className="fe fe-plus btn btn-primary add-new-product-to-invoice-btn"
                      onClick={addNewProductToInvoice}
                    ></i>
                    <i
                      className="fe fe-edit btn btn-primary edit-single-product"
                      onClick={editSingleInvoiceProduct}
                    ></i>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewDevis;
